import { render, staticRenderFns } from "./template-editor.vue?vue&type=template&id=a75663e8&scoped=true"
import script from "./template-editor.vue?vue&type=script&lang=js"
export * from "./template-editor.vue?vue&type=script&lang=js"
import style0 from "./template-editor.vue?vue&type=style&index=0&id=a75663e8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75663e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a75663e8')) {
      api.createRecord('a75663e8', component.options)
    } else {
      api.reload('a75663e8', component.options)
    }
    module.hot.accept("./template-editor.vue?vue&type=template&id=a75663e8&scoped=true", function () {
      api.rerender('a75663e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/template-editor.vue"
export default component.exports